import { render, staticRenderFns } from "./tenantauth-list.vue?vue&type=template&id=44a0f3fa&"
import script from "./tenantauth-list.vue?vue&type=script&lang=js&"
export * from "./tenantauth-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tenantauth-list.vue"
export default component.exports